import { render, staticRenderFns } from "./ScanQRCode.vue?vue&type=template&id=64e87fc7&"
import script from "./ScanQRCode.vue?vue&type=script&lang=js&"
export * from "./ScanQRCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports